"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDateFormatter = getDateFormatter;
const constants_js_1 = require("../../constants.js");
const formatInternationalDate_js_1 = require("../date/formatInternationalDate.js");
function getDateFormatter(intlFormatters) {
    const formatMediumDate = (date) => intlFormatters.formatDate(date, constants_js_1.formats.date.medium);
    return (date, options = 'medium') => {
        if (typeof options === 'string') {
            if (options === 'international') {
                return (0, formatInternationalDate_js_1.formatInternationalDate)(date);
            }
            return formatMediumDate(date);
        }
        return intlFormatters.formatDate(date, options);
    };
}
//# sourceMappingURL=getDateFormatter.js.map